import React, {useContext, useState} from "react";
import {Image} from "../Image";
import {ModalContext} from "../modal/ModalContext";


export const ImageDialog = ({imageSrc = null, handler, args}) => {
    const [message, setMessage] = useState('Click on pic or on button')
    const {showModal} = useContext(ModalContext)

    /*const reduntantlocalHandler = (e) => {
        if (e.target.files) {
            if (multy) {
                uploadHandler(e.target.files, args)
                setMessage(Object.keys(e.target.files).reduce(
                    (result, key) =>
                        result + '"' + e.target.files[key].name + '", ',
                    ''))
            } else {
                uploadHandler(e.target.files[0], args)
                setMessage(e.target.files[0].name)
                setSrc(URL.createObjectURL(e.target.files[0]))
            }
        }
    }*/

    const localHandler = () => {
        showModal((newLink) => {
            handler(newLink, args)
            setMessage('Image changed')
        })
    }

    return (
        <div className='horizontal'>
            <div className='multiple-fields-container' style={{flex: 1}}>
                {imageSrc ? (
                    <Image
                        style={{maxWidth: '90%', cursor: 'pointer'}}
                        src={imageSrc}
                        className='imageButton'
                        onClick={localHandler}
                    />
                ) : <h3 className='text-muted'>No image here</h3>}
                <button
                    className='float-left'
                    style={{maxWidth: '80%', margin: 0, marginTop: '20px'}}
                        onClick={localHandler}>
                    Choose file
                </button>
            </div>
            <div style={{flex: '1'}}>
                <h5>{message}</h5>
            </div>
        </div>
    )
}